/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from "@angular/core";
import {AbstractSaveUserService, UserModel, UsersService} from "@irian-ro/auth-web-client";
import {Observable, switchMap, take} from "rxjs";
import {UserCompanyTypeResourceService} from "@well/resource-services";
import {LoggedInContext, WellContextService} from "@well/shared-providers";
import {map} from "rxjs/operators";

@Injectable({providedIn: 'root'})
export class UserWithCompanyTypeService implements AbstractSaveUserService{

  constructor(private userCompanyTypeResourceService: UserCompanyTypeResourceService,
              private usersService: UsersService,
              private wellContextService: WellContextService) {
  }

  getNewUser(): Observable<UserModel> {
    return this.wellContextService.getLoggedInContext().pipe(
      take(1),
      switchMap((loggedInContext: LoggedInContext) => {
        return this.userCompanyTypeResourceService.findTemplateByCompanyType(loggedInContext.companyType)
      }),
      map(res => this.extractDataFieldIfExists(res))
    );
  }

  getUserById(uuid: string): Observable<UserModel> {
    return this.wellContextService.getLoggedInContext().pipe(
      take(1),
      switchMap((loggedInContext: LoggedInContext) => {
        return this.userCompanyTypeResourceService.findOneByCompanyType(uuid, loggedInContext.companyType)
      }),
      map(res => this.extractDataFieldIfExists(res))
    );
  }

  saveUserRights(userModel: UserModel): Observable<any> {
    return this.usersService.saveUserRights(userModel);
  }

  private extractDataFieldIfExists(resource: any){
    if(resource.data === undefined){
      return resource;
    }
    return resource.data;
  }
}
